import React, { useState } from 'react';
import { RequestEntity, IItemUsers } from 'types';
import classNames from 'classnames';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import AdditionallyInfoView from './components/AdditionallyInfoView';
import AdditionalInfoSwitch from './components/AdditionalInfoSwitch';
import MainInfoView from './components/MainInfoView';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './Info.module.scss';

interface IInfo {
	isOpenInfo: boolean;
	data: IItemUsers;
}

const Info: React.FC<IInfo> = ({ isOpenInfo, data }) => {
	const [infoMode, setInfoMode] = useState<'main' | 'additional'>('main');
	const isDeleted = !!data.deletedDate;
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });
	const imgWrapperClass = classNames(style.imgWrapper, { [style.itemDisabled]: isDeleted });

	const getDefaultAvatar = () => {
		return (
			<svg className={style.avatar}>
				<use xlinkHref={`${breadcrumbs}#userAvatar${data.roleName}`} />
			</svg>
		);
	};

	const defaultAvatar = getDefaultAvatar();

	return (
		<div className={containerClasses} data-test="Info">
			<AdditionalInfoSwitch infoMode={infoMode} setInfoMode={setInfoMode} />
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={imgWrapperClass}>
						{data.filePath ? (
							<ImgUploaderByEntityId
								resource={RequestEntity.Users}
								entityID={data.id}
								photoSize="Small"
								isMakeImageRequest={isOpenInfo}
								loaderSize="small"
							/>
						) : (
							defaultAvatar
						)}
					</div>
					{infoMode === 'main' ? <MainInfoView data={data} /> : <AdditionallyInfoView data={data} />}
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
